import { useTranslation } from 'react-i18next'
import { connect, useDataItem } from 'scrivito'

import { ActivityTab } from '../SharedTabs/ActivityTab/ActivityTab'
import { DocumentTab } from '../SharedTabs/DocumentTab/DocumentTab'
import { InvoiceTab } from '../SharedTabs/InvoiceTab/InvoiceTab'
import { MessageTab } from '../SharedTabs/MessageTab/MessageTab'
import { NavTabs, NavTabItem } from '@/Atomic/Templates/NavTabs'
import { NavTab } from '@/Atomic/Widgets/DataItemTabs/const'
import { ActivityProjectRelation } from '@/Data/ActivityProjectRelation/ActivityProjectRelationDataClass'
import { DataClassName } from '@/Data/const'
import { DocumentProjectRelation } from '@/Data/DocumentProjectRelation/DocumentProjectRelationDataClass'
import { Invoice } from '@/Data/Invoice/InvoiceDataClass'
import { Message } from '@/Data/Message/MessageDataClass'
import { useFeatureFlagAccess } from '@/utils/featureFlagConfig'

const ALL_NAV_TABS: NavTab[] = [
  NavTab.ACTIVITY,
  NavTab.INVOICE,
  NavTab.MESSAGE,
  NavTab.DOCUMENT,
]

export const OrderDataItemTabs: React.FC = connect(() => {
  const { t } = useTranslation()
  const { filterTabs } = useFeatureFlagAccess()
  const dataItem = useDataItem()
  const dataItemId = dataItem?.id() ?? ''

  if (!dataItemId) return

  const visibleNavTabs = filterTabs(ALL_NAV_TABS)
  const isVisible = (tab: NavTab) => visibleNavTabs.includes(tab)

  const activityCount = isVisible(NavTab.ACTIVITY)
    ? (ActivityProjectRelation.all()
        .transform({ filters: { project: dataItemId } })
        .count() ?? 0)
    : 0

  const invoiceCount = isVisible(NavTab.INVOICE)
    ? (Invoice.all()
        .transform({ filters: { order: dataItemId } })
        .count() ?? 0)
    : 0

  const messageCount = isVisible(NavTab.MESSAGE)
    ? (Message.all()
        .transform({ filters: { subjectId: dataItemId } })
        .count() ?? 0)
    : 0

  const documentCount = isVisible(NavTab.DOCUMENT)
    ? (DocumentProjectRelation.all()
        .transform({ filters: { project: dataItemId } })
        .count() ?? 0)
    : 0

  const tabsByNavTab: Array<{ navTab: NavTab; tab: NavTabItem }> = [
    {
      navTab: NavTab.ACTIVITY,
      tab: {
        id: 'activities',
        title: t('pages.activities.title'),
        icon: 'activity',
        count: activityCount,
        content: (
          <ActivityTab
            searchInputName="search order-activity"
            activityRelation="project"
          />
        ),
      },
    },
    {
      navTab: NavTab.INVOICE,
      tab: {
        id: 'invoices',
        title: t('components.invoice.title'),
        icon: 'invoice',
        count: invoiceCount,
        content: (
          <InvoiceTab
            searchInputName="search order-invoice"
            subjectRelation="order"
          />
        ),
      },
    },
    {
      navTab: NavTab.MESSAGE,
      tab: {
        id: 'messages',
        title: t('components.message.title'),
        icon: 'note',
        count: messageCount,
        content: <MessageTab />,
      },
    },
    {
      navTab: NavTab.DOCUMENT,
      tab: {
        id: 'documents',
        title: t('components.document.documents'),
        icon: 'file-empty',
        count: documentCount,
        content: (
          <DocumentTab relationTo={DataClassName.DOCUMENT_PROJECT_RELATION} />
        ),
      },
    },
  ]

  const tabs: NavTabItem[] = tabsByNavTab
    .filter((entry) => isVisible(entry.navTab))
    .map((entry) => entry.tab)

  if (!tabs.length) return

  return <NavTabs tabs={tabs} />
})
